import React from 'react';
import { graphql } from 'gatsby';
import { EditoralCTABlock as EditoralCTABlockComponent } from '../../EditoralCTABlock';

export const EditoralCTABlock = ({ data, ...rest }) => <EditoralCTABlockComponent {...data} {...rest} />;

export const EditoralCTABlockQuery = graphql`
  fragment EditoralCTABlock on KFH_UmbracoEditoralCtaBlockComponentType {
    title
    lead
    html
    linkLists {
      ...LinkList
    }
    button {
      ...Button
    }
    imageCards {
      ...ImageCardPagePicker
      ...ImageCardCustom
    }
    alignment
  }
`;
